// Mock data para desenvolvimento

// Dados completos do André para teste do plano de sono
export const mockAndreData = {
  id: '4d4c782c-299e-4007-8696-a413eb3c77b5',
  babyName: 'André',
  babyAge: 10,
  birthWeeks: 39,
  birthDate: '2025-03-15',
  motherName: 'Patrícia Santos',
  fatherName: 'Leandro Santos',
  email: 'leandro.160787@gmail.com',
  whatsapp: '11999999999',
  status: 'pending_analysis',
  createdAt: '2025-01-06',
  
  initialForm: {
    sleepDifficulty: 'André acorda muitas vezes durante a noite, entre 4 a 6 vezes, e só volta a dormir mamando. Estamos exaustos.',
    expectations: 'Gostaria que ele dormisse pelo menos 6 horas seguidas e aprendesse a adormecer sem precisar do peito',
    previousAttempts: 'Tentamos reduzir mamadas gradualmente mas não conseguimos manter a consistência. Também tentamos a chupeta mas ele não aceita.',
    healthConditions: 'Nenhuma condição especial',
    heelPrickTest: 'Normal, todos os exames ok',
    snoring: 'Não ronca',
    ironSupplementation: 'Sim, suplementa ferro conforme orientação do pediatra',
    feedingType: 'Aleitamento materno com complemento de fórmula à noite',
    solidFoods: 'Sim, come bem no almoço e jantar. Frutas de manhã e à tarde.',
    motorDevelopment: 'Engatinha bem rápido, fica em pé apoiado nos móveis, dá alguns passinhos com apoio',
    howBabySleeps: 'Mamando no peito ou sendo ninado no colo',
    sleepLocation: 'Berço no quarto dos pais',
    transitionObject: true,
    transitionObjectDesc: 'Naninha de ursinho que gosta de segurar',
    caregiver: 'Mãe cuida durante o dia, pai ajuda à noite e nos finais de semana',
    otherChildren: 'Não, André é o primeiro filho',
    motherSleep: 'Muito prejudicado, acordo várias vezes e não consigo mais dormir direito. Afetando meu humor e disposição no trabalho.'
  },
  
  routineDays: [
    {
      day: 1,
      date: '2025-01-06',
      completed: true,
      wakeUpTime: '06:45',
      bedTime: '21:30',
      nightWakings: 5,
      nightWakingsDuration: '10-20 min cada vez',
      naps: [
        { startTime: '09:00', duration: 40, timeToSleep: 20, howSlept: 'Mamando no peito', whereSlept: 'Colo' },
        { startTime: '12:30', duration: 90, timeToSleep: 15, howSlept: 'Mamando no peito', whereSlept: 'Berço' },
        { startTime: '16:00', duration: 30, timeToSleep: 25, howSlept: 'Ninando no colo', whereSlept: 'Colo' }
      ],
      routineDescription: '06:45 - Acordou chorando. 07:00 - Mamou no peito...',
      importantNotes: 'Dia difícil, muito agitado. Não quis dormir cedo.'
    },
    {
      day: 2,
      date: '2025-01-07',
      completed: true,
      wakeUpTime: '07:15',
      bedTime: '20:45',
      nightWakings: 4,
      nightWakingsDuration: '15 min em média',
      naps: [
        { startTime: '09:30', duration: 50, timeToSleep: 15, howSlept: 'Mamando no peito', whereSlept: 'Berço' },
        { startTime: '13:00', duration: 75, timeToSleep: 20, howSlept: 'Mamando no peito', whereSlept: 'Berço' }
      ],
      routineDescription: '07:15 - Acordou sozinho, bem humorado...',
      importantNotes: 'Dia mais tranquilo, apenas 2 sonecas mas dormiu melhor à noite.'
    },
    {
      day: 3,
      date: '2025-01-08',
      completed: true,
      wakeUpTime: '06:30',
      bedTime: '21:00',
      nightWakings: 6,
      nightWakingsDuration: '20-30 min, uma vez ficou 45min acordado',
      naps: [
        { startTime: '08:45', duration: 35, timeToSleep: 25, howSlept: 'Mamando no peito', whereSlept: 'Colo' },
        { startTime: '11:30', duration: 60, timeToSleep: 30, howSlept: 'Ninando no colo', whereSlept: 'Berço' },
        { startTime: '15:00', duration: 45, timeToSleep: 20, howSlept: 'Mamando no peito', whereSlept: 'Colo' }
      ],
      routineDescription: '06:30 - Acordou cedo chorando muito...',
      importantNotes: 'Pior noite da semana. Acho que está em salto de desenvolvimento, muito grudento.'
    },
    {
      day: 4,
      date: '2025-01-09',
      completed: true,
      wakeUpTime: '07:00',
      bedTime: '20:30',
      nightWakings: 4,
      nightWakingsDuration: '10-15 min',
      naps: [
        { startTime: '09:15', duration: 55, timeToSleep: 15, howSlept: 'Mamando no peito', whereSlept: 'Berço' },
        { startTime: '13:30', duration: 80, timeToSleep: 10, howSlept: 'Mamando no peito', whereSlept: 'Berço' }
      ],
      routineDescription: '07:00 - Acordou tranquilo...',
      importantNotes: 'Melhor dia! Dormiu bem as sonecas e foi mais fácil colocar para dormir à noite.'
    },
    {
      day: 5,
      date: '2025-01-10',
      completed: true,
      wakeUpTime: '06:50',
      bedTime: '20:15',
      nightWakings: 5,
      nightWakingsDuration: '15-20 min',
      naps: [
        { startTime: '09:00', duration: 45, timeToSleep: 20, howSlept: 'Mamando no peito', whereSlept: 'Berço' },
        { startTime: '13:00', duration: 70, timeToSleep: 15, howSlept: 'Mamando no peito', whereSlept: 'Berço' }
      ],
      routineDescription: '06:50 - Acordou. 07:00 - Mamou...',
      importantNotes: 'Dia equilibrado. Noite ainda com despertares mas conseguimos manter rotina mais consistente.'
    }
  ]
};

export const mockBabyData = {
  id: 'report-001',
  babyName: 'Helena',
  babyAge: 12,
  birthWeeks: 39,
  birthDate: '2024-01-15',
  motherName: 'Camila Silva',
  fatherName: 'Lucas Silva',
  email: 'camila@email.com',
  whatsapp: '11999998888',
  status: 'pending_routine', // pending_form, pending_routine, pending_analysis, pending_approval, approved
  createdAt: '2025-01-10',
  
  // Formulário inicial
  initialForm: {
    sleepDifficulty: 'Meu bebê acorda muitas vezes durante a noite e só volta a dormir mamando',
    expectations: 'Quero conseguir dormir pelo menos 6 horas seguidas e que meu bebê aprenda a dormir sozinho',
    previousAttempts: 'Tentei deixar chorar um pouco mas não consegui manter, me senti muito mal',
    healthConditions: 'Não possui',
    heelPrickTest: 'Normal',
    snoring: 'Às vezes ronca levemente',
    ironSupplementation: 'Não',
    feedingType: 'Aleitamento materno exclusivo até 6 meses, agora misto',
    solidFoods: 'Sim, introdução alimentar aos 6 meses, come bem no almoço e jantar',
    motorDevelopment: 'Engatinha, fica em pé apoiada, dá alguns passinhos com apoio',
    howBabySleeps: 'Mamando no peito ou ninando no colo',
    sleepLocation: 'Berço no quarto dos pais',
    transitionObject: true,
    transitionObjectDesc: 'Naninha de coelhinho',
    caregiver: 'Eu cuido durante o dia, meu marido ajuda à noite nos finais de semana',
    otherChildren: 'Não, é o primeiro filho',
    motherSleep: 'Estou exausta, acordo várias vezes e isso está afetando meu humor e disposição'
  },
  
  // Registro de rotina 5 dias
  routineDays: [
    {
      day: 1,
      date: '2025-01-11',
      completed: true,
      wakeUpTime: '07:30',
      bedTime: '21:00',
      nightWakings: 4,
      nightWakingsDuration: '15-30 min cada',
      naps: [
        { startTime: '09:30', duration: 45, timeToSleep: 20, howSlept: 'mamando', whereSlept: 'colo' },
        { startTime: '13:00', duration: 90, timeToSleep: 15, howSlept: 'mamando', whereSlept: 'berço' },
        { startTime: '16:30', duration: 30, timeToSleep: 25, howSlept: 'ninando', whereSlept: 'colo' }
      ],
      routineDescription: '07:30 Acordou, 07:45 Mamou, 08:00 Café da manhã (frutas), 08:30 Brincou no tapete, 09:15 Bocejou e coçou os olhos, 09:30 Primeira soneca no colo mamando...',
      importantNotes: 'Estava mais agitada que o normal, talvez por conta do calor'
    },
    {
      day: 2,
      date: '2025-01-12',
      completed: true,
      wakeUpTime: '06:45',
      bedTime: '20:30',
      nightWakings: 3,
      nightWakingsDuration: '10-20 min cada',
      naps: [
        { startTime: '09:00', duration: 60, timeToSleep: 15, howSlept: 'mamando', whereSlept: 'berço' },
        { startTime: '13:30', duration: 75, timeToSleep: 20, howSlept: 'mamando', whereSlept: 'berço' }
      ],
      routineDescription: '06:45 Acordou sozinha, 07:00 Mamou, 07:30 Café da manhã...',
      importantNotes: ''
    },
    { day: 3, date: '2025-01-13', completed: false },
    { day: 4, date: '2025-01-14', completed: false },
    { day: 5, date: '2025-01-15', completed: false }
  ]
};

export const mockReports = [
  {
    id: '4d4c782c-299e-4007-8696-a413eb3c77b5',
    babyName: 'André',
    motherName: 'Patrícia Santos',
    email: 'leandro.160787@gmail.com',
    babyAge: 10,
    status: 'pending_analysis',
    createdAt: '2025-01-06',
    completedDays: 5
  },
  {
    id: 'report-001',
    babyName: 'Helena',
    motherName: 'Camila Silva',
    babyAge: 12,
    status: 'pending_routine',
    createdAt: '2025-01-10',
    completedDays: 2
  },
  {
    id: 'report-002',
    babyName: 'Miguel',
    motherName: 'Ana Paula',
    babyAge: 8,
    status: 'pending_analysis',
    createdAt: '2025-01-08',
    completedDays: 5
  },
  {
    id: 'report-003',
    babyName: 'Sofia',
    motherName: 'Juliana Costa',
    babyAge: 6,
    status: 'approved',
    createdAt: '2025-01-05',
    completedDays: 5
  }
];

export const sleepMethods = {
  ferber: {
    name: 'Extinção Graduada (Ferber)',
    description: 'Intervalos progressivos de checagem',
    suitable: ['6+ meses', 'Associação forte de sono', 'Pais consistentes'],
    evidence: 'Alta'
  },
  chair: {
    name: 'Método da Cadeira',
    description: 'Presença gradualmente reduzida no quarto',
    suitable: ['4+ meses', 'Ansiedade de separação', 'Transição suave'],
    evidence: 'Moderada'
  },
  pickUpPutDown: {
    name: 'Pegar e Colocar',
    description: 'Consolar no colo e devolver ao berço',
    suitable: ['3-8 meses', 'Bebês mais novos', 'Pais que preferem contato'],
    evidence: 'Moderada'
  },
  bedtimeFading: {
    name: 'Esvanecimento do Horário',
    description: 'Ajuste gradual do horário de dormir',
    suitable: ['Qualquer idade', 'Resistência para dormir', 'Abordagem suave'],
    evidence: 'Alta'
  },
  positiveRoutines: {
    name: 'Rotinas Positivas',
    description: 'Ritual consistente e previsível',
    suitable: ['Qualquer idade', 'Base para qualquer método', 'Fundamental'],
    evidence: 'Alta'
  }
};

export const ageBasedRecommendations = {
  '0-3': {
    wakingWindow: '45min - 1h30',
    naps: '4-5 sonecas',
    nightSleep: '14-17h total',
    notes: 'Foco em higiene do sono e resposta sensível'
  },
  '4-6': {
    wakingWindow: '1h30 - 2h30',
    naps: '3-4 sonecas',
    nightSleep: '12-15h total',
    notes: 'Pode iniciar rotinas mais estruturadas'
  },
  '7-9': {
    wakingWindow: '2h30 - 3h30',
    naps: '2-3 sonecas',
    nightSleep: '12-14h total',
    notes: 'Transição para 2 sonecas'
  },
  '10-12': {
    wakingWindow: '3h - 4h',
    naps: '2 sonecas',
    nightSleep: '11-14h total',
    notes: 'Janelas mais longas, rotina consistente'
  },
  '12-18': {
    wakingWindow: '3h45 - 5h',
    naps: '1-2 sonecas',
    nightSleep: '11-14h total',
    notes: 'Transição para 1 soneca por volta dos 15 meses'
  }
};

export const sleepSignals = [
  'Boceja',
  'Coça os olhos',
  'Puxa a orelha',
  'Fica irritado/choroso',
  'Olhar fixo/vidrado',
  'Olhos vermelhos',
  'Movimentos mais lentos',
  'Busca o peito/chupeta',
  'Esfrega o rosto',
  'Perde interesse nas brincadeiras'
];

export const howBabySleepsOptions = [
  'Mamando no peito',
  'Mamando na mamadeira',
  'Ninando no colo',
  'No carrinho',
  'No carro',
  'Com chupeta',
  'Sendo embalado',
  'Com música/ruído branco',
  'Sozinho no berço',
  'Outro'
];

export const whereBabySleepsOptions = [
  'Berço no quarto dos pais',
  'Berço no próprio quarto',
  'Cama compartilhada',
  'Colo',
  'Carrinho',
  'Cadeirinha',
  'Rede',
  'Outro'
];
